// React
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router';
// ユーティリティ
import { validationSchema } from '../../../utils/validationUtils';
import { errorMessages } from '../../../utils/messagesUtils';

import sty from './PasswordReset.module.css';

const PasswordResetInput = ({ setIsSuccess, role }) => {
    // バリデーションの設定
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'onBlur',
    });

    const { token } = useParams();
    const [errorFromServer, setErrorFromServer] = useState('');

    const onSubmit = async (data) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/password/reset/${token}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ...data, "role": role }),
                credentials: 'include'
            });
            const result = await response.json();
            if (response.status === 200 && result.status == 'OK') {
                setIsSuccess(true); // 成功時に親コンポーネントの状態を更新
            } else {
                if(result.message === 'token_invalid'){
                    setErrorFromServer(errorMessages.password_reset.token_invalid)
                } else if(result.message === 'token_expired'){
                    setErrorFromServer(errorMessages.password_reset.token_expired)
                } else {
                    setErrorFromServer(errorMessages.password_reset.failed)
                }
            }
        } catch (e) {
            // サーバーエラー
            setErrorFromServer(errorMessages.api.network_error)
        }
    };

    // パスワード表示切替
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordConfirmVisible, setPasswordConfirmVisible] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const togglePasswordConfirmVisibility = () => {
        setPasswordConfirmVisible(!passwordConfirmVisible);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} >
            <div className="page-tit">
                <div className="page-tit-outer">
                    <p className="page-tit-txt">
                        パスワード再設定
                    </p>
                    <div className="page-tit-border"></div>
                </div>
            </div>
            <div className="inner-container">
            {errorFromServer && <p className='account-error-msg'>{errorFromServer}</p>}
                <div className={sty['pwd-reset__pass']}>
                    <div className={sty['pwd-reset__pass-tit']}>
                        <label htmlFor="password">パスワード</label>
                    </div>
                    <div className={sty['pwd-reset__pass-pass-tit']}>
                        <div className={sty['pwd-reset__pass-pass-ex']}>
                            <input
                                {...register('password', validationSchema.password)}
                                type={passwordVisible ? 'text' : 'password'}
                                className={sty['pwd-reset__pass-input-field']}
                                placeholder="パスワードを入力してください"
                                id="password"
                            />
                            {errors.password && <p className="form__validation-msg">{errors.password.message}</p>}
                            <img
                                src={passwordVisible ? '/images/open.svg' : '/images/hidden.svg'}
                                alt="パスワード表示・非表示"
                                className={`${sty['pwd-reset__pass-toggle']} ${passwordVisible ? sty['pwd-reset__pass-toggle--open'] : ''}`}
                                onClick={togglePasswordVisibility}
                            />
                        </div>
                    </div>
                </div>
                <div className={sty['pwd-reset__pass']}>
                    <div className={sty['pwd-reset__pass-tit']}>
                        <label htmlFor="password_confirm">パスワード(確認用)</label>
                    </div>
                    <div className={sty['pwd-reset__pass-pass-tit']}>
                        <div className={sty['pwd-reset__pass-pass-ex']}>
                            <input
                                {...register('pwd_confirm', validationSchema.pwd_confirm)}
                                type={passwordConfirmVisible ? 'text' : 'password'}
                                className={sty['pwd-reset__pass-input-field']}
                                placeholder="パスワードを再入力してください"
                                id="pwd_confirm"
                            />
                            {errors.pwd_confirm && <p className="form__validation-msg">{errors.pwd_confirm.message}</p>}
                            <img
                                src={passwordConfirmVisible ? '/images/open.svg' : '/images/hidden.svg'}
                                alt="確認用パスワード表示・非表示"
                                className={`${sty['pwd-reset__pass-toggle']} ${passwordConfirmVisible ? sty['pwd-reset__pass-toggle--open'] : ''}`}
                                onClick={togglePasswordConfirmVisibility}
                            />
                        </div>
                    </div>
                </div>
                <button type="submit" className="primary-btn btn-large">登録</button>
            </div>
        </form>
    );
};

export default PasswordResetInput;
